import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  isToken: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false,
  isToken: false
}

export const access = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_ACCESS_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_ACCESS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_ACCESS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
        isToken: true
      }
      case actionTypes.CLEAR_ACCESS_DATA:
        return {
          ...state,
          data: {},
          isToken: false
        }
    default:
      return state;
  }
}
